import script from "./PoliticaPrivacidade.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticaPrivacidade.vue?vue&type=script&setup=true&lang=js"

import "./PoliticaPrivacidade.vue?vue&type=style&index=0&id=5e48f8e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e48f8e8"]])

export default __exports__